<!-- @format -->

<template>
	<pcp-role-picker
		ref="userPickerRef"
		v-model="userValue"
		style="width: 100%"
		:dialog-props="dialogProps"
		@on-confirm="onConfirm"
		@on-select="onSelect"
	>
		<template #default="{ onClick, ...args }">
			<el-input :model-value="value.toString()" placeholder="请选择角色" v-bind="args" @click="onShowRole(onClick)" />
		</template>
		<template #detail>
			<el-select
				multiple
				:model-value="linkFieldsValue"
				:teleported="false"
				class="selectUserClass"
				popper-class="selectUserPopper"
				@remove-tag="onRemove"
			/>
		</template>
	</pcp-role-picker>
</template>

<script setup lang="ts">
	import { FieldsType, type WidgetConfigType } from '../../types';
	import { flat } from '../../utils/util';
	import { getCheckRowsToFormDatas, getFormDatasToStrArr, getStrArrToFormDatas } from '../../utils/user';

	import type { Ref } from 'vue';
	import { PcpRolePicker } from '@/p-components';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const attrs = useAttrs();

	const setFieldsValue = inject<(fields: Record<string, any>) => void>('setFieldsValue', () => {});
	const widgetDatas = inject<Ref<FieldsType[]>>('widgetDatas', ref([]));
	const formDatas = inject<Record<string, any>>('formDatas', {});

	const dialogProps = {
		'append-to-body': false,
		class: 'pickerClass',
		width: '830px',
	};

	const userPickerRef = ref<InstanceType<typeof PcpRolePicker> | null>(null);

	const userValue = ref([]);

	const value = computed({
		get() {
			return props.modelValue ? props.modelValue.split(',') : [];
		},
		set(value) {
			emit('update:modelValue', value.toString());
		},
	});

	const linkFieldsValue = ref<string[]>([]);

	const flatWigetDatas = computed(() => flat(widgetDatas.value || []));

	const onShowRole = (callback) => {
		const list = getFormDatasToStrArr(props.pcProps.linkConfig, flatWigetDatas.value, formDatas.value);
		linkFieldsValue.value = list;
		callback();
	};

	const onSelect = (checkRows) => {
		if (checkRows.value.length) {
			const formDatas = getCheckRowsToFormDatas(props.pcProps.linkConfig, flatWigetDatas.value, checkRows.value);
			const values = getFormDatasToStrArr(props.pcProps.linkConfig, flatWigetDatas.value, formDatas);

			const list = attrs.multiple ? Array.from(new Set([...linkFieldsValue.value, ...values])) : [...values];

			linkFieldsValue.value = list;
		}
	};

	const onRemove = (e) => {
		linkFieldsValue.value = linkFieldsValue.value.filter((i) => i !== e);
	};

	const onConfirm = (_, __) => {
		const fields = getStrArrToFormDatas(props.pcProps.linkConfig, flatWigetDatas.value, linkFieldsValue.value);
		setFieldsValue && setFieldsValue(fields);

		userPickerRef.value!.checkRows = [];
	};
</script>

<style lang="scss" scoped>
	.selectUserClass {
		width: 100%;
		margin-bottom: 10px;

		:deep(.selectUserPopper) {
			visibility: hidden;
		}
	}
</style>

<style lang="scss">
	.pickerClass {
		.el-form {
			margin-bottom: 18px;
		}
	}
</style>
